import React, { useCallback, useEffect, useState } from 'react';

import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import DietaryTagStore from '../flux/stores/DietaryTagStore';
import FileDownload from '@mui/icons-material/SaveAlt';
import Footer from './Footer';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import LineLengthActions from '../flux/actions/ResidentialLocationActions';
import { Link } from 'react-router-dom';
import MediaQuery from 'react-responsive';
import MenuIcon from '@mui/icons-material/Menu';
import MoreVert from '@mui/icons-material/MoreVert';
import Navigation from './Navigation';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import ReactModal from 'react-modal';
import Search from './Search';
import SearchIcon from '@mui/icons-material/Search';
// import Snackbar from './Snackbar';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import classNames from 'classnames';
import { logIn } from '../utility/index.js';
import { useMatches } from 'react-router-dom';

ReactModal.setAppElement('#app');

const drawerWidth = 308;

const Layout = (props) => {
  const { classes, children, locationPicker, match, menuLink, pageName, AppContext, locations, currentUser, GET_USER } = props;
  const [openNav, setOpenNav] = useState(false);
  const [openSearch, setOpenSearch] = useState(false);
  const [showLocations, setShowLocations] = useState(false);
  // const [showAdditional, setShowAdditional] = useState(false);
  const [showEstimate, setShowEstimate] = useState(false);
  const [additional, setAdditional] = useState(false);
  const [success, setSuccess] = useState(false);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [lineLengthValue, setLineLengthValue] = useState();
  const [ballot, setBallot] = useState();
  const [filters, setFilters] = useState();
  const [highlightString, setHighlightString] = useState("");
  const [showOnlyString, setShowOnlyString] = useState("");
  const [hiddenString, setHiddenString] = useState("");
  const [dietaryTags, setDietaryTags] = useState();

  let currentMeals;
  let mealsEnabled = false;
  let anchor = false; // Not sure how this was previously set in state
  const matches = useMatches();
  let displayMenuDownload = matches.filter((match) => Boolean(match.handle)).map((match) => match.handle.displayMenu)[0];

  const _userPreferanceChange = useCallback(() => {
    if (currentUser !== "Guest" && Object.keys(currentUser).length !== 0) {
      setFilters(DietaryTagStore.getUserDietaryTags());
    }
  }, [currentUser]);
  
  const _tagChange = useCallback(() => {
    let tagFetch = DietaryTagStore.getDietaryTags();
    setDietaryTags(tagFetch);
  }, []);

  // Fetch User settings filters to pass along to children components (specifically location page/hidden dialogs); 
  useEffect(() => {
    let _userPreferanceChangeToken = DietaryTagStore.addListener(_userPreferanceChange);
    _userPreferanceChange();
    let _tagChangeToken = DietaryTagStore.addListener(_tagChange);
    _tagChange();
    return () => {
      _userPreferanceChangeToken.remove();
      _tagChangeToken.remove();
    };
  }, [_userPreferanceChange, _tagChange]);

  useEffect(() => {
    if (filters && filters !== undefined) {
      let highlightValue = '';
      let showOnlyValue = '';
      let hiddenValue = '';
      filters.Flagged.forEach((val, key, arr) => {
        if (Object.is(arr.length - 1, key)) {
          highlightValue = highlightValue + val;
        } else {
          highlightValue = highlightValue + val + ', ';
        }
      });

      filters.ShowOnly.forEach((val, key, arr) => {
        if (Object.is(arr.length - 1, key)) {
          showOnlyValue = showOnlyValue + val;
        } else {
          showOnlyValue = showOnlyValue + val + ', ';
        }
      });

      filters.Hidden.forEach((val, key, arr) => {
        if (Object.is(arr.length - 1, key)) {
          hiddenValue = hiddenValue + val;
        } else {
          hiddenValue = hiddenValue + val + ', ';
        }
      });

      setHighlightString(highlightValue);
      setShowOnlyString(showOnlyValue);
      setHiddenString(hiddenValue);
    }
  }, [filters])


  useEffect(() => {
    if (typeof window !== "undefined") {
      window.addEventListener('resize', updateWindowDimensions);
      updateWindowDimensions();
      return () => {
        window.removeEventListener('resize', updateWindowDimensions);
      };
    }
  }, []);

  function updateWindowDimensions() {
    if (typeof window !== "undefined") {
      setDimensions({ width: window.innerWidth, height: window.innerHeight });
    } else {
      setDimensions({ width: 1024, height: 768 }); // Default dimensions for SSR
    }
  }


  function castBallot() {
    if (lineLengthValue) {
      LineLengthActions.castLineLengthBallot(locationPicker[1], lineLengthValue);
      setLineLengthValue();
      setSuccess(true);
    }
  }

  function handleChange(value) {
    setLineLengthValue(value);
  };


  function handleEstimate() {
    if (currentUser === "Guest") {
      logIn()
    }
    else if (!showEstimate) {
      LineLengthActions.getBallot(locationPicker[1])
        .then(result => setBallot(result.data));
    }
    setSuccess(false);
    setAdditional(false);
    setShowEstimate(!showEstimate);
  }

  function handleMenu() {
    setAdditional(!additional);
  }

  function handleLocations() {
    setShowLocations(!showLocations);
  }

  // function handleAdditional() {
  //   //clear the location drop down
  //   if (showLocations === true) {
  //     handleLocations();
  //   }
  //   setShowAdditional(!showAdditional);
  // }

  function handleDrawer() {
    //clear the location drop down
    if (showLocations === true) {
      handleLocations();
    }
    setOpenNav(!openNav);
  };

  function handleSearch() {
    //clear the location drop down
    if (showLocations === true) {
      handleLocations();
    }
    setOpenSearch(!openSearch);
  };

  // function selectLocation(location, e) {
  //   //do redirect function here
  //   handleLocations();
  // }

  function renderTitle() {
    if (pageName === ' ') {
      return <div className={"mdl-layout-title "}>
        <Link to="/" className={"purdue-logo-link"}><span className="purdue-logo">PU Logo</span></Link>
      </div>
    }
    else if (pageName !== 'Home') {
      return <div className={"mdl-layout-title "}>
        <a className="purdue-logo-link" href="https://purdue.edu"><span className="purdue-logo">PU Logo</span></a>
        <h1 className={"page-title"}>{pageName}</h1>
      </div>
    } else {
      return <div className={"mdl-layout-title "}>
        <a className="purdue-logo-link" href="https://purdue.edu"><span className="purdue-logo">PU Logo</span></a>
        <Link to="/" className={"home-link "}><h1>Dining Menus</h1></Link>
      </div>
    }
  }

  if (children && children.props && children.props.meals && children.props.meals.length > 0) {
    currentMeals = children.props.meals.map(function (x, i) {
      if (x.Stations.length > 0) {
        return true;
      } else {
        return false;
      }
    });
    currentMeals.forEach(function (x) {
      if (x === true) {
        mealsEnabled = true;
      }
    })
  };

  let additionalNavigation = displayMenuDownload ? <div>
    <MediaQuery minDeviceWidth={768}>
      <Tooltip classes={{
        tooltip: "md-tooltip"
      }} title="Download Menu">
          <IconButton href={menuLink} className="md-download--icon" aria-label="Download the menu for this location.">
            <FileDownload />
          </IconButton>
      </Tooltip>
    </MediaQuery>

    <MediaQuery maxDeviceWidth={767}>
      <IconButton onClick={() => handleMenu()} aria-label="More" aria-haspopup="true" aria-owns={anchor ? 'additional-menu' : null} className="md-group--icon">
        <MoreVert />
      </IconButton>
      {additional ? <div className="obfusicator" onClick={() => handleMenu()}></div> : null}
      {additional ? <div key="additional-menu" className="additional-menu">
        <div className="additional-menu--options">
          <ul role="list" aria-label="Additional menu options">
            {mealsEnabled === true ? <li aria-label="Download the menu for this location."><a href={"https://" + menuLink} className="additional-menu--download" onClick={() => handleMenu()} download>Download Menu</a></li> : null}
          </ul>
        </div>
      </div> : null}
    </MediaQuery>
  </div> : null;

  let options = ballot ? ballot.Prompt !== "Please wait until this court opens in order to provide an estimate." ? ballot.LineLengthOptions.map((option) => {
    return (
      <FormControlLabel key={"key_" + option.LineLengthOptionId} value={option.LineLengthOptionId} control={<Radio />} label={option.DisplayText} />
    );
  }) : null : null;
  let ballotContent = ballot ? success ?
    <div className="rm-estimate-line-length--container">
      <h4 className="rm-estimate-line-length__title rm-estimate-line-length__title--accent">Estimate Submitted</h4>
      <div className="rm-estimate-line-length__content">
        <p>{ballot.Explanation}</p>
      </div>
      <div className="rm-estimate-line-length__actions">
        <Button color="secondary" onClick={() => handleEstimate()}>
          Close
        </Button>
      </div>
    </div>

    : (
      <div className="rm-estimate-line-length--container">
        <h4 className="rm-estimate-line-length__title rm-estimate-line-length__title--accent">My Estimate</h4>
        <div className="rm-estimate-line-length__content">

          <p className="choice-label">{ballot.Prompt}</p>

          <RadioGroup
            aria-label="Estimate Line Length Ballot Options"
            name="ballot"
            value={lineLengthValue}
            onChange={handleChange}
          >
            {options}
          </RadioGroup>
          <p><em>{ballot.Explanation}</em></p>
        </div>
        <div className="rm-estimate-line-length__actions">
          <Button color="secondary" onClick={() => castBallot()}>
            Save
          </Button>
          <Button color="secondary" onClick={() => handleEstimate()}>
            Cancel
          </Button>
        </div>
      </div>
    ) : <div></div>;

  let styleprops = dimensions.width > 1224 ? { width: `calc(100% - ${drawerWidth}px)`, float: 'right' } : {};

  return (

    <div>
      <AppBar
        className={dimensions.width < 1224 ? "mdl-layout__header" : classNames(classes) + " mdl-layout__header"}
        style={styleprops}
      >
        <Toolbar className="md-layout__header--toolbar">
          {dimensions.width < 1224 ? <IconButton className="md-drawer--icon" onClick={() => handleDrawer()} aria-label="Main Navigation Menu">
            <MenuIcon />
          </IconButton> : null}
          {renderTitle()}
          {additionalNavigation ? additionalNavigation : null}
          <IconButton className="md-search--icon" onClick={() => handleSearch()} aria-label="Search for a menu item">
            <SearchIcon />
          </IconButton>
        </Toolbar>
      </AppBar>
      {showLocations ? <div className="obfusicator" onClick={() => handleLocations()}></div> : ""}
      <Navigation 
        locations={locations} 
        currentUser={currentUser} 
        match={match} 
        handleDrawer={() => handleDrawer()} 
        open={openNav} 
        anchor="left" 
      />
      <div>
        {/* <Snackbar currentUser={currentUser} /> */}
        {/* // width={dimensions.width} styleprops={styleprops} currentUser={user} locationsarray={locations} GET_USER={GET_USER}> */}
        <AppContext.Provider value={{
          width: dimensions.width,
          styleprops: styleprops,
          currentUser: currentUser,
          locationsarray: locations,
          GET_USER: GET_USER,
          highlightString: highlightString,
          showOnlyString: showOnlyString,
          hiddenString: hiddenString,
          filters: filters,
          dietaryTags: dietaryTags
        }}
        >
          {children}
        </AppContext.Provider>
        <Footer width={dimensions.width} styleprops={styleprops} />
      </div>
      <Search handleSearch={() => handleSearch()} open={openSearch} anchor="left" />

      <ReactModal className="rm-estimate-line-length" isOpen={showEstimate} onRequestClose={() => handleEstimate()} contentLabel={"My Estimate"} ariaHideApp={showEstimate} shouldCloseOnOverlayClick={true} role="dialog">
        {ballot ?
          ballotContent
          :
          null
        }
      </ReactModal>
    </div>
  );
}

export default Layout;